import {Sprite} from 'pixi.js';
import {Stack} from '../pixi_scene/game_scene/game_table/table_objects/stacks/Stack';
import {ActiveDataCommandsController} from '../controllers/ActiveDataCommandsController';
import {ArrayWrapEventData} from '../data/active_data/base/static_config_data/array_wrap/ArrayWrapEventData';
import {CardStackData} from '../data/active_data/field_config/CardStackData';

export class Stacks extends Sprite
{
    stacks: Stack[] = [];

    protected constructor() {

        super();
    }

    /**
     * Получить содержащиеся колоды
     */
    getStacks(): Stack[] {
        return this.stacks;
    }

    /**
     * Удаляем временные колоды
     * @param data
     */
    checkTempStacks(): void {
        let tempStacks: Stack[] = this.stacks.filter(stack => stack.tempOnTable);
        tempStacks.forEach(tempStack => ActiveDataCommandsController.removeTempStack(tempStack));
    }

    /**
     * Регистрируем и отрисовываем колоду в холдере
     * @param stack - добавляемая в холдер колода
     */
    protected async addStack(stack: Stack, initialize: boolean = false): Promise<void> {
        this.stacks.push(stack);
        initialize && await stack.initialize();
        this.addChild(stack);
    }

    /**
     * Убираем колоду из холдера
     * @param {Stack} stack - убираемая из холдера колода
     */
    protected removeStack(stack: Stack) {
        this.stacks.splice(this.stacks.indexOf(stack), 1);
        this.removeChild(stack);
    }

    /**
     * Обработчик события данных ELEMENT_ADDED
     * @param data
     */
    protected async onStackAdded(data: ArrayWrapEventData<CardStackData>): Promise<void> {
        this.checkTempStacks();
    }
}
